module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/button-star-hover_VA.9696e6f3.svg";